import { atom } from "@reatom/framework";

export const activeOrderFilter = atom<"current" | "completed">(
  "current",
  "activeOrderFilter"
);
